// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1dhqJ","legacyBtn":"MutateMid_legacyBtn__1GtZs"};